import { render, staticRenderFns } from "./CustomActivityTraineeAssignment.vue?vue&type=template&id=5bf115a8&scoped=true"
import script from "./CustomActivityTraineeAssignment.vue?vue&type=script&lang=js"
export * from "./CustomActivityTraineeAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf115a8",
  null
  
)

export default component.exports